/**
 * 前端生成 Excel 并触发下载（基于 Export2Excel + xlsx）
 */
export function buildExportFilename(prefix) {
  const pad = n => String(n).padStart(2, '0')
  const d = new Date()
  const stamp = `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}_${pad(d.getHours())}${pad(
    d.getMinutes()
  )}${pad(d.getSeconds())}`
  return `${prefix}_${stamp}`
}

export function downloadExcel({ header, data, filename, autoWidth = true, bookType = 'xlsx' }) {
  return import('@/vendor/Export2Excel').then(excel => {
    excel.export_json_to_excel({
      header,
      data,
      filename: filename || 'export',
      autoWidth,
      bookType,
    })
  })
}
